import React, {useContext, useEffect, useState} from 'react';
import GeneralContext from "../context/GeneralProvider";
import Video from "./Video";
import Name from "./Name";
import Origin from "./Origin";

function Profile() {
    const {video,origin} = useContext(GeneralContext)
    const [page, setPage] = useState(<Name/>);

    useEffect(() => {
        if(video){
            setPage(<Video/>)
        }else{
            if(origin){
                setPage(<Origin/>)
            }else{
                setPage(<Name/>)
            }
        }
    },[origin,video])


    return (
        <>{page}</>
    );
}

export default Profile;